export default __webpack_public_path__ + "static/media/ms.6dbda66c.png";